module.exports = function (discounts) {
  return discounts && discounts.some(discount => discount.amount > 0);
};
